





































































import { defineComponent, reactive, toRefs } from '@vue/composition-api';
import ProcessModel from '@/components/ProcessModel/index.vue';
import Clounms from '@/components/Cloumns/index.vue';
import titleBox from '@/components/Box/index.vue';
import addComma from '@/utils/addComma';
import Pagination from '@/components/Pagination';
import request from '@utils/request';
import { isCore } from '@/useable/login';
import svgCom from '@components/Svg/index';

export default defineComponent({
  name: 'billDetail',
  components: {
    Clounms,
    titleBox,
    Pagination,
    ProcessModel,
    svgCom,
  },
  setup(props: any, { root }: any) {
    const state = reactive({
      loginstatus: false,
      total: 0,
      totalRepayment: 0,
      pageSize: 10,
      pageSizeRepayment: 10,
      page: 1,
      pageRepayment: 1,
      dataFinanceDetailId: '2',
      tableConfigRepayment: {
        column: [
          { key: 'custom', label: '序号', custom: true, width: 50 },
          {
            key: 'repaymentTotalAmount',
            label: '还款总金额',
            custom: true,
            align: 'right',
            headerAlign: 'right',
          },
          {
            key: 'repaymentAmount',
            label: '还款本金',
            custom: true,
            align: 'right',
            headerAlign: 'right',
          },
          {
            key: 'repaymentInterest',
            label: '还款利息',
            custom: true,
            align: 'right',
            headerAlign: 'right',
          },
          { key: 'repaymentDate', label: '还款日期' },
        ],
        data: [],
      },
      tableConfig: {
        column: [
          { key: 'custom', label: '序号', custom: true, width: 50 },
          { key: 'companyName', label: '处理方' },
          { key: 'operator', label: '处理人' },
          { key: 'operateStep', label: '处理步骤' },
          { key: 'operateAction', label: '处理意见' },
          { key: 'operateTime', label: '处理时间' },
          { key: 'nextStepName', label: '下个处理节点' },
        ],
        data: [],
      },
      processData: [
        {
          title: '银行融资受理',
          date: '',
          time: '',
          num: 1,
          choose: false,
        },
        {
          title: '银行放款',
          date: '',
          time: '',
          num: 2,
          choose: false,
        },
        {
          title: '完成还款',
          date: '',
          time: '',
          num: 3,
          choose: false,
        },
      ],
      cloumnsData: [
        {
          title: '融资申请单号',
          value: '',
        },
        {
          title: '融资企业名称',
          value: '',
        },
        {
          title: '融资金额',
          value: '',
        },
        {
          title: '融资银行',
          value: '',
        },
        {
          title: '融资申请日期',
          value: '',
        },
        {
          title: '融资还款利息',
          value: '',
        },
        {
          title: '申请人',
          value: '',
        },
        {
          title: '融资申请状态',
          value: '',
        },
        {
          title: '融资还款状态',
          value: '',
        },
        {
          title: '融资利率',
          value: '',
        },
        {
          title: '已还款金额',
          value: '',
        },
        {
          title: '剩余还款金额',
          value: '',
        },
      ],
    });
    const getBillDetail = async () => {
      const res = await request('dataFinancing', 'getdataFinancingList', {
        applyNo: root.$route.params.applyNo,
        current: 1,
        pageSize: 10,
      });
      if (res.code === 2000) {
        const [result] = res.data.dataList;
        const [
          applyNo,
          vendorName,
          applyAmount,
          bankName,
          applyDate,
          totalRepaymentInterest,
          applyOperator,
          applyStatusName,
          repaymentStatsName,
          financeRate,
          repaymentAmount,
          unpaidAmount,
        ] = state.cloumnsData;
        applyNo.value = result.applyNo;
        vendorName.value = result.vendorName;
        applyAmount.value = `${addComma(result.applyAmount)} CNY`;
        bankName.value = result.bankName;
        applyDate.value = result.applyDate;
        totalRepaymentInterest.value = `${addComma(
          result.totalRepaymentInterest,
        )} CNY`;
        applyOperator.value = result.applyOperator;
        applyStatusName.value = result.applyStatusName;
        repaymentStatsName.value = result.repaymentStatsName;
        financeRate.value = result.financeRate;
        repaymentAmount.value = `${addComma(result.repaymentAmount)} CNY`;
        unpaidAmount.value = `${addComma(result.unpaidAmount)} CNY`;

        state.dataFinanceDetailId = result.id;

        if (['受理中', '融资失败'].includes(result.applyStatusName)) {
          state.processData[0].choose = true;
        } else if (result.repaymentStatsName === '已还款') {
          state.processData[0].choose = true;
          state.processData[1].choose = true;
          state.processData[2].choose = true;
        } else if (result.applyStatusName === '已放款') {
          state.processData[0].choose = true;
          state.processData[1].choose = true;
        }
      }
    };
    const getDate = (data, index) => {
      switch (index) {
        case 0:
          return data.orderApplyTime ? data.orderApplyTime.split(' ')[0] : '';
          break;
        case 1:
          return data.invoiceReceiveTime
            ? data.invoiceReceiveTime.split(' ')[0]
            : '';
          break;
        case 2:
          return data.invoiceConfirmTime
            ? data.invoiceConfirmTime.split(' ')[0]
            : '';
          break;
        case 3:
          return data.postPayTime ? data.postPayTime.split(' ')[0] : '';
          break;
        case 4:
          return data.paidTime ? data.paidTime.split(' ')[0] : '';
          break;
        case 5:
          return data.operateTime ? data.operateTime.split(' ')[0] : '';
          break;
        default:
          return data.orderApplyTime ? data.orderApplyTime.split(' ')[0] : '';
          break;
      }
    };
    const getTime = (data, index) => {
      switch (index) {
        case 0:
          return data.orderApplyTime ? data.orderApplyTime.split(' ')[1] : '';
          break;
        case 1:
          return data.invoiceReceiveTime
            ? data.invoiceReceiveTime.split(' ')[1]
            : '';
          break;
        case 2:
          return data.invoiceConfirmTime
            ? data.invoiceConfirmTime.split(' ')[1]
            : '';
          break;
        case 3:
          return data.postPayTime ? data.postPayTime.split(' ')[1] : '';
          break;
        case 4:
          return data.paidTime ? data.paidTime.split(' ')[1] : '';
          break;
        case 5:
          return data.operateTime ? data.operateTime.split(' ')[1] : '';
          break;
        default:
          return data.orderApplyTime ? data.orderApplyTime.split(' ')[1] : '';
          break;
      }
    };
    const getFinanceLogList = async () => {
      const res = await request('dataFinancing', 'getFinanceLogList', {
        dataFinanceDetailId: state.dataFinanceDetailId,
        current: state.page,
        pageSize: state.pageSize,
      });
      if (res.code === 2000) {
        state.tableConfig.data = res.data.dataList;
        state.total = res.data.total;
      }
    };
    const getRepaymentList = async () => {
      const res = await request('dataFinancing', 'repaymentList', {
        dataFinanceDetailId: state.dataFinanceDetailId,
        current: state.pageRepayment,
        pageSize: state.pageSizeRepayment,
      });

      if (res.code === 2000) {
        state.tableConfigRepayment.data = res.data.dataList;
        state.totalRepayment = res.data.total;
      }
    };
    const ApplyForFinancing = async () => {
      root.$router.push({
        path: '/Financing/edit/editOne',
      });
    };
    if (isCore.value) {
      state.loginstatus = true;
    } else {
      state.loginstatus = false;
    }
    getBillDetail().then(() => {
      getFinanceLogList();
      getRepaymentList();
    });

    const back = () => {
      history.go(-1);
    };
    const pageChange = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      getFinanceLogList();
    };
    const pageChangeRepayment = (newPage, newSize) => {
      state.page = newPage;
      state.pageSize = newSize;
      getRepaymentList();
    };
    return {
      ...toRefs(state),
      ApplyForFinancing,
      pageChange,
      pageChangeRepayment,
      getBillDetail,
      back,
      addComma,
    };
  },
});
